import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

export default function LinkButton({ to, children, ...rest }) {
  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Button {...rest}>{children}</Button>
    </Link>
  );
}

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};
